module.exports = __webpack_public_path__ + "img/pingtai@2x.0ba1fa3d.png";